export default __webpack_public_path__ + "static/media/laundry2-before-768w.98cf597b.avif";